export const splitFlavoursTitle = (string: string): string[] => {
    const words = string.split(' ');

    if (words.length < 2) {
        return words;
    }

    return [words[0], words.slice(1).join(' ')];
};
